import { Controller } from '@hotwired/stimulus';

// Détendeur lié d'un nouveau périphérique (adhérent du bureau) : au changement de propriétaire (`user_owned`), détendeurs du
// client ou de l'adhérent relus (JSON de `url`), liste remplacée.
export default class extends Controller {
    static values = { url: String };

    async reload({ target }) {
        if (target.name !== 'user_owned') return;
        const select = this.element.querySelector('select');
        let list;
        try {
            const response = await fetch(`${this.urlValue}?${new URLSearchParams({ state: target.value === 'true' })}`,
                                         { headers: { Accept: 'application/json' } });
            if (!response.ok) return;
            ({ regulators_list: list } = await response.json());
        } catch {
            return;
        }
        const blank = select.querySelector('option[value=""]');
        const options = Object.entries(list).filter(([, id]) => Number(id) > 0).map(([label, id]) => new Option(label, id));
        select.replaceChildren(...[blank].filter(Boolean), ...options);
        select.value = '';
        select.dispatchEvent(new CustomEvent('combobox:render', { bubbles: true }));
    }
}
